import { A, a } from "./Accordion-Beb7dV7U.js";
import { u as useSpacing, f as useBorder, e as useBackground, b as useDimensions, d as useTypography, k as useOutline, B as Box } from "./Grid-CcQKdsgp.js";
import { G } from "./Grid-CcQKdsgp.js";
import { B, a as a2 } from "./Breadcrumbs-DJwPIoLC.js";
import { B as B2 } from "./Button-BduN4i4I.js";
import { C } from "./Card-B7kgkdup.js";
import { C as C2 } from "./Checkbox-DQv1WUai.js";
import { C as C3 } from "./Container-BvvFVgfr.js";
import { D } from "./Dropdown-eMOyXxG3.js";
import { F as Flex } from "./Flex-BqkSIn_m.js";
import { H } from "./HeadingBlock-BhNQ4DeX.js";
import { Image } from "./image.js";
import { M } from "./Markdown-B_ZQWLYf.js";
import { M as M2, a as a3 } from "./Modal-DWkORYdK.js";
import { P } from "./Pagination-Dlgc27WP.js";
import { S, T, u } from "./Tabs-BvJrxnW9.js";
import { D as D2, P as P2 } from "./Dialog-BhH212Dy.js";
import { P as P3 } from "./Popover-B1B60g-t.js";
import { S as S2, a as a4, b } from "./Select-ZKqMbNXI.js";
import { S as S3 } from "./Skeleton-Dey6OE1k.js";
import { jsx, Fragment, jsxs } from "react/jsx-runtime";
import { T as T2 } from "./Table-ZOVch60E.js";
import { T as T3 } from "./Text-Dc_bpDe5.js";
import { T as T4 } from "./TextField-BQJtegSb.js";
import React, { forwardRef, useState, useRef } from "react";
import { T as Typography } from "./Typography-BcQZigNB.js";
import { useTextField } from "@react-aria/textfield";
import { T as T5 } from "./Title-Lqw04_OD.js";
import { U, c } from "./provider-AWbIw7oQ.js";
import { u as u2 } from "./useUiKitComponents-CaMIXGvd.js";
import { u as u3 } from "./useUiKitTheme-C9zsuTl3.js";
const Spinner = (props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const borderProps = props == null ? void 0 : props.border;
  const borderColor = typeof (borderProps == null ? void 0 : borderProps.color) === "string" ? void 0 : borderProps == null ? void 0 : borderProps.color;
  return /* @__PURE__ */ jsx(
    Flex,
    {
      ...props,
      width: (_a = props == null ? void 0 : props.width) != null ? _a : 32,
      height: (_b = props.height) != null ? _b : 32,
      border: {
        color: {
          top: (_c = borderColor == null ? void 0 : borderColor.top) != null ? _c : "border-primary",
          bottom: (_d = borderColor == null ? void 0 : borderColor.bottom) != null ? _d : "border-subtle",
          left: (_e = borderColor == null ? void 0 : borderColor.left) != null ? _e : "border-subtle",
          right: (_f = borderColor == null ? void 0 : borderColor.right) != null ? _f : "border-subtle"
        },
        radius: (_g = borderProps == null ? void 0 : borderProps.radius) != null ? _g : "50%",
        width: (_h = borderProps == null ? void 0 : borderProps.width) != null ? _h : "2px"
      },
      className: "animate-spin",
      children: props.children
    }
  );
};
const getLabelProps = ({
  variant,
  isFocused,
  value
}) => {
  const hasValue = isFocused || !!value;
  const variants = {
    primary: {
      as: "label",
      position: {
        type: "absolute",
        left: "32px",
        top: hasValue ? "6px" : "16px"
      },
      opacity: hasValue ? 50 : void 0,
      color: "text-secondary-default",
      fontSize: hasValue ? "body.mobile.xsmall" : "body.mobile.large",
      md: {
        fontSize: hasValue ? "body.desktop.xsmall" : "body.desktop.large",
        lineHeight: hasValue ? "body.desktop.xsmall" : "body.desktop.large"
      },
      lineHeight: hasValue ? "body.mobile.small" : "body.mobile.large"
    },
    secondary: {
      as: "label",
      position: {
        type: "absolute",
        left: "12px",
        top: hasValue ? "7px" : "15px"
      },
      opacity: hasValue ? 50 : void 0,
      color: isFocused ? "text-selection" : "text-secondary-default",
      fontSize: hasValue ? "body.mobile.xsmall" : "body.mobile.medium",
      md: {
        fontSize: hasValue ? "body.desktop.xsmall" : "body.desktop.medium",
        lineHeight: hasValue ? "body.desktop.xsmall" : "body.desktop.medium"
      },
      lineHeight: hasValue ? "body.mobile.small" : "body.mobile.medium"
    }
  };
  return variants[variant];
};
const getErrorMessageProps = ({
  variant
}) => {
  const variants = {
    primary: {
      as: "p",
      fontSize: "body.mobile.small",
      lineHeight: "body.mobile.small",
      fontWeight: "mobile.normal",
      md: { fontWeight: "desktop.normal" },
      color: "text-destructive",
      m: { mt: 2, ml: 32 }
    },
    secondary: {
      as: "p",
      fontSize: "body.mobile.small",
      lineHeight: "body.mobile.small",
      fontWeight: "mobile.normal",
      md: { fontWeight: "desktop.normal" },
      m: { mt: 4 },
      color: "text-destructive"
    }
  };
  return variants[variant];
};
const DEFAULT_SPACINGS = {
  padding: { primary: [26, 32, 8, 32], secondary: [22, 12, 6, 12] }
};
const getOutlineProps = ({
  variant,
  isError,
  isFocused
}) => {
  const variants = {
    primary: {
      m: {
        outlineColor: isError ? "text-destructive" : "surface-neutral-dark-default",
        outlineWidth: "1px"
      }
    },
    secondary: {
      m: {
        outlineColor: isError ? "text-destructive" : isFocused ? "border-selected" : "surface-neutral-dark-default",
        outlineWidth: "1px"
      }
    }
  };
  return variants[variant];
};
const getBorderProps = ({
  variant,
  isError,
  isFocused
}) => {
  const variants = {
    primary: {
      m: {
        color: isError ? "text-destructive" : "surface-neutral-dark-default",
        width: "1px",
        radius: "form"
      }
    },
    secondary: {
      m: {
        color: isError ? "text-destructive" : isFocused ? "border-selected" : "surface-neutral-dark-default",
        width: "1px",
        radius: "form"
      }
    }
  };
  return variants[variant];
};
const getBackgroundProps = ({
  variant
}) => {
  const variants = {
    primary: {
      m: {
        bg: "surface-neutral-dark-default",
        bgSize: "cover",
        bgRepeat: "no-repeat",
        bgPosition: "center"
      }
    },
    secondary: {
      m: {
        bg: "surface-neutral-dark-default",
        bgSize: "cover",
        bgRepeat: "no-repeat",
        bgPosition: "center"
      }
    }
  };
  return variants[variant];
};
const getDimensionProps = ({
  variant
}) => {
  const variants = {
    primary: {
      m: {
        width: "100%",
        height: "100%",
        maxHeight: "56px"
      }
    },
    secondary: {
      m: {
        width: "100%",
        height: "100%",
        maxHeight: "48px"
      }
    }
  };
  return variants[variant];
};
const TextFieldV2 = forwardRef((props, ref) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D;
  const {
    label,
    icon,
    errorMessage,
    name,
    type,
    className,
    customInput,
    onChange: _onChange,
    spellCheck: _spellCheck,
    variant = "primary",
    ...rest
  } = props;
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef(null);
  const fieldLabel = typeof label === "string" ? label : "input-label";
  const { inputProps } = useTextField(
    {
      ...props,
      label: fieldLabel,
      inputElementType: "input"
    },
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    ref != null ? ref : inputRef
  );
  const spacing = useSpacing({
    m: {
      p: rest.p,
      m: rest.m
    },
    md: rest.md,
    d: rest.d,
    defaultPadding: (_a = DEFAULT_SPACINGS == null ? void 0 : DEFAULT_SPACINGS.padding) == null ? void 0 : _a[variant]
  });
  const border = useBorder({
    m: {
      ...getBorderProps({ variant, isError: !!errorMessage, isFocused }).m,
      ...rest.border
    },
    md: (_b = rest == null ? void 0 : rest.md) == null ? void 0 : _b.border,
    d: (_c = rest == null ? void 0 : rest.d) == null ? void 0 : _c.border,
    hover: {
      m: (_d = rest == null ? void 0 : rest.hover) == null ? void 0 : _d.border,
      md: (_f = (_e = rest == null ? void 0 : rest.md) == null ? void 0 : _e.hover) == null ? void 0 : _f.border,
      d: (_h = (_g = rest == null ? void 0 : rest.d) == null ? void 0 : _g.hover) == null ? void 0 : _h.border
    }
  });
  const background = useBackground({
    m: {
      ...getBackgroundProps({ variant }).m,
      ...props
    },
    md: (_i = props == null ? void 0 : props.md) != null ? _i : {},
    d: (_j = props.d) != null ? _j : {},
    hover: {
      m: (_k = props.hover) != null ? _k : {},
      md: (_m = (_l = props.md) == null ? void 0 : _l.hover) != null ? _m : {},
      d: (_o = (_n = props.d) == null ? void 0 : _n.hover) != null ? _o : {}
    }
  });
  const dimension = useDimensions({
    m: {
      ...getDimensionProps({ variant }).m,
      ...rest
    },
    md: rest.md,
    d: rest.d
  });
  const typography = useTypography({
    m: {
      fontSize: (_p = rest.fontSize) != null ? _p : "body.mobile.medium",
      lineHeight: (_q = rest == null ? void 0 : rest.lineHeight) != null ? _q : "body.mobile.medium",
      ...rest
    },
    md: (_r = rest == null ? void 0 : rest.md) != null ? _r : {},
    d: (_s = rest == null ? void 0 : rest.d) != null ? _s : {},
    hover: {
      m: (_t = rest == null ? void 0 : rest.hover) != null ? _t : {},
      md: (_v = (_u = rest == null ? void 0 : rest.md) == null ? void 0 : _u.hover) != null ? _v : {},
      d: (_x = (_w = rest == null ? void 0 : rest.d) == null ? void 0 : _w.hover) != null ? _x : {}
    }
  });
  const outline = useOutline({
    m: {
      ...getOutlineProps({ variant, isError: !!errorMessage, isFocused }).m,
      ...rest
    },
    md: rest == null ? void 0 : rest.md,
    d: rest == null ? void 0 : rest.d,
    hover: {
      m: (_y = rest == null ? void 0 : rest.hover) != null ? _y : {},
      md: (_A = (_z = rest == null ? void 0 : rest.md) == null ? void 0 : _z.hover) != null ? _A : {},
      d: (_C = (_B = rest == null ? void 0 : rest.d) == null ? void 0 : _B.hover) != null ? _C : {}
    }
  });
  const Label = label && typeof label !== "string" ? label({ isFocused, value: inputProps.value }) : /* @__PURE__ */ jsx(Fragment, {});
  const Icon = icon ? icon == null ? void 0 : icon({ isDisabled: (_D = inputProps == null ? void 0 : inputProps.disabled) != null ? _D : false }) : /* @__PURE__ */ jsx(Fragment, {});
  return /* @__PURE__ */ jsxs(Box, { position: { type: "relative" }, children: [
    typeof label === "string" ? /* @__PURE__ */ jsx(
      Typography,
      {
        ...getLabelProps({
          variant,
          isFocused,
          value: inputProps.value
        }),
        children: label
      }
    ) : Label,
    customInput ? React.cloneElement(customInput, {
      ...rest,
      ...inputProps,
      ref,
      onClick: inputProps.onClick,
      className: `${border.className} ${background.className} ${spacing.className} ${dimension.className} ${typography.classNames} ${outline.className} ${className}`,
      style: {
        ...border.style,
        ...background.style,
        ...spacing.styles,
        ...dimension.styles,
        ...typography.styles,
        ...outline.style
      },
      onFocus: () => setIsFocused(true),
      onBlur: () => setIsFocused(false)
    }) : /* @__PURE__ */ jsx(
      "input",
      {
        ...inputProps,
        ...rest,
        ref,
        value: inputProps.value,
        name,
        type,
        className: ` ${border.className} ${background.className} ${spacing.className} ${dimension.className} ${typography.classNames} ${outline.className} ${className}`,
        onFocus: () => setIsFocused(true),
        onBlur: () => setIsFocused(false),
        style: {
          ...border.style,
          ...background.style,
          ...spacing.styles,
          ...dimension.styles,
          ...typography.styles,
          ...outline.style
        }
      }
    ),
    icon && /* @__PURE__ */ jsx(Fragment, { children: Icon }),
    typeof errorMessage === "string" ? /* @__PURE__ */ jsx(Typography, { ...getErrorMessageProps({ variant }), children: errorMessage }) : errorMessage
  ] });
});
export {
  A as Accordion,
  a as AccordionContext,
  Box,
  B as BreadcrumbItem,
  a2 as Breadcrumbs,
  B2 as Button,
  C as Card,
  C2 as Checkbox,
  C3 as Container,
  D2 as Dialog,
  D as Dropdown,
  Flex,
  G as Grid,
  H as HeadingBlock,
  Image,
  M as Markdown,
  M2 as Modal,
  a3 as ModalTrigger,
  P as Pagination,
  P3 as Popover,
  P2 as PopoverTrigger,
  S2 as Select,
  a4 as SelectOption,
  b as SelectOptionList,
  S3 as Skeleton,
  Spinner,
  S as StripeWrapper,
  T2 as Table,
  T as Tabs,
  T3 as Text,
  T4 as TextField,
  TextFieldV2,
  T5 as Title,
  Typography,
  U as UIKitProvider,
  c as createTheme,
  u as useClientPagination,
  u2 as useUiKitComponents,
  u3 as useUiKitTheme
};
